module.exports = __webpack_public_path__ + "img/symbol_deletered.3f72ac51.png";